import React, { useState } from 'react';
import PurchaseListTemplate from '../../../pages/purchase/components/PurchaseListTemplate';
import { PurchaseTabScene, PurchaseInfo } from '../../../types/process/purchase';
import { useDefaultQueryFields } from '../../../pages/purchase/purchase.effect';
import PurchaseTriggerActionMap, { PurchaseTriggerActionProvider, PurchaseTriggerTarget } from '../../../pages/purchase/components/PurchaseTriggerActionMap';

const PurchaseDeclaredList: React.FC = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const reloadList = () => setRefreshKey(k => k + 1);
  const queryFields = useDefaultQueryFields(PurchaseTabScene.Declared);

  const renderTableActions = (order: PurchaseInfo) => {
    const targets: PurchaseTriggerTarget[] = ['viewPurchase'];
    if (!order.purchase.deviceImei) {
      targets.push('fillImei');
    }
    return <PurchaseTriggerActionMap targets={targets} purchase={order} onReload={reloadList} />;
  };

  return (
    <PurchaseTriggerActionProvider onReload={reloadList}>
      <PurchaseListTemplate
        title="已申报列表"
        refreshKey={refreshKey}
        queryFields={queryFields}

        tabScene={PurchaseTabScene.Declared}
        defaultScene={PurchaseTabScene.Declared}
        viewModes={React.useMemo(() => [
          {
            mode: 'table' as const,
            label: '表格页',
            renderActions: renderTableActions,
            showField: 'tab_declared'
          }
        ], [renderTableActions])}
      />
    </PurchaseTriggerActionProvider>
  );
};

export default PurchaseDeclaredList;
